import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import * as eventActions from '../../actions/event-actions';
import { fetchComponentConfig } from '../../actions/component-config-actions';
import PlayersTabContent from '../../components/EventProfile/PlayersTabContent';
import { setAuthHeader } from '../../actions';

const WebViewEventPlayers = (props) => {
    const parsed = queryString.parse(props.location.search);
    const { jwt, memberId: currentMemberId } = parsed;
    if (jwt) {
        props.setAuthHeader({ jwt });
    }

    const event = props.events.currentEvent.data;

    // TODO: This error is never used, wire this up.
    // eslint-disable-next-line
    const [error, setError] = useState();

    const getEvent = async () => {
        await props.getEvent(props.match.params.eventId);
        if (props.events.currentEvent.error) {
            setError(true);
        }
    };

    useEffect(() => {
        props.getComponentConfig(props.match.params.eventId);
    }, []);

    useEffect(() => {
        // eslint-disable-next-line eqeqeq
        if (!props.events.currentEvent.isLoading && props.events.currentEvent.data?.id != props.match.params.eventId) {
            getEvent();
        }
    }, [props.events.currentEvent.data, props.events.currentEvent.isLoading]);

    const sendMessage = (recipient) => {
        const { memberId, displayName } = recipient;
        if (currentMemberId && memberId) {
            props.history.push(`/webview/messaging/${currentMemberId}?rid=${memberId}&rname=${displayName}`);
        }
    };

    return (event ? (
        <div className="p24" data-testid="webview.event-players.container">
            <PlayersTabContent
                isCurrentMemberAdmin={false}
                sendMessage={sendMessage}
                showRatingNotLoggedIn={true}
                data-testid="webview.event-players.players-content"
            />
        </div>
    ) : null);
};

function mapDispatchToProps(dispatch) {
    return {
        getEvent: (eventId) => {
            return dispatch(eventActions.getEvent(eventId, false, false, false, false, true));
        },
        getComponentConfig: (eventId) => {
            return dispatch(fetchComponentConfig('event-profile', { eventId }));
        },
        setAuthHeader: ({ jwt }) => {
            return dispatch(setAuthHeader({ jwt }));
        },
    };
}

function mapStateToProps({ events }) {
    return { events };
}

const component = connect(mapStateToProps, mapDispatchToProps)(WebViewEventPlayers);

export default {
    component,
    loadData: ({ dispatch }, match) => {
        dispatch(eventActions.getEventMetaData(match.params.eventId));
        dispatch(eventActions.getEvent(match.params.eventId, false, false, false, false, true));
    },
};
